import { render, staticRenderFns } from "./ProductPriceForm.vue?vue&type=template&id=4a9030a4&"
import script from "./ProductPriceForm.vue?vue&type=script&lang=js&"
export * from "./ProductPriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports